import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import CreateInstallationForm from "../../../../components/InstrallationWorkForm/RecordDetail/CreateIntrallationForm";
import InformInstallJobsService from "../../../../services/informinstalljob.service";
import InformInstallItemsService from "../../../../services/informinstallitem.service";
import InstallServicePricesService from "../../../../services/installserviceprice.service";
import InformInstallItemBomsService from "../../../../services/informinstallitembom.service";
import InformInstallJobFilesService from "../../../../services/informinstalljobfile.service";
import FileUploadsService from "../../../../services/fileupload.service";
import CreateInstallationBomForm from "../../../../components/InstrallationWorkForm/RecordDetail/CreateInstallationBomForm";

export default function EditInstallation() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [editData, setEditData] = useState({ type: "edit" });

  const commonNavigate = (Install_Id) => {
    const state = {
      name: "edit",
      searchValue: `${Install_Id}`
    };
    navigate("/installation_work/record", { state });
  };

  const commonNavigateBom = (Install_Id) => {
    navigate("/installation_work/record", {
      state: { name: "edit", searchValue: `${Install_Id}`, type: "Bom" }
    });
    navigate(0);
  };

  const handleSubmit = (
    { Install, Install_Item, ServicePrice },
    uploadFile
  ) => {
    const files = [
      ...uploadFile.Image.filter((item) => item instanceof File),
      ...uploadFile.Video.filter((item) => item instanceof File)
    ];

    const refreshAt =
      files?.length > 0
        ? "InformFiles"
        : Install_Item.Array
        ? "InstallItem"
        : ServiceInstall.Array
        ? "ServiceInstall"
        : "Install";
    const Install_Id = Install?.Array?.[0]?.Id;
    handleSubmitInformInstallJob({ Install, Install_Id, refreshAt });

    if (Install_Item?.Array) {
      handleSubmitInstallItem({ Install_Item, Install_Id, refreshAt });
    }

    if (ServicePrice?.Array)
      handleSubmitServiceInstall({ ServicePrice, Install_Id, refreshAt });

    if (files?.length > 0)
      handleUploadFile({
        destination: "ใบแจ้งงานติดตั้ง/Media",
        files,
        Install_Id,
        refreshAt,
      });
  };

  const handleSubmitInformInstallJob = ({
    Install,
    Install_Id,
    refreshAt,
  }) => {
    const modifiedItem = Install.Array.map(
      ({
        Id,
        Contract_No,
        Job_Type_Id,
        Job_Type_Sub_Id,
        Employee_Id,
        Cus_Id,
        Bp_Code_Id,
        InformInstallJobFile,
        JobType,
        JobTypeSub,
        Customer,
        BPCustomer,
        Employee,
        InformInstallItem,
        InstallServicePrice,
        createdAt,
        createdBy,
        updatedAt,
        updatedBy,
        ...item
      }) => ({
        ...item,
        Job_Type_Id: Number(Job_Type_Id) || null,
        Job_Type_Sub_Id: Number(Job_Type_Sub_Id) || null,
        Cus_Id: Number(Cus_Id) || null,
        Employee_Id: Number(Employee_Id) || null
      })
    )?.[0];

    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InformInstallJobsService.editInformInstallJobs(
        Install_Id,
        modifiedItem
      ),
      navigated: (navi) =>
        navi && refreshAt === "Install" && commonNavigate(Install_Id)
    });
  };

  const handleSubmitInstallItem = ({
    Install_Item,
    Install_Id,
    refreshAt,
  }) => {
    Install_Item?.Array?.forEach(
      ({
        Id,
        Asset,
        Item,
        Item_Id,
        Item_Install_Qty,
        Asset_Code,
        InformInstallItemBom,
        Item_Serial,
        ...item
      }) => {
        const modifiedItem = {
          ...item,
          Job_Install_Id: Install_Id,
          Item_Id: Number(Item_Id) || null,
          Item_Install_Qty: Number(Item_Install_Qty) || null,
          Asset_Code: Asset_Code?.toString() || null,
          Uom_Unit: Item ? Item.Unit : Asset.Asset_Unit
        };
        const serviceRequest = Id
          ? InformInstallItemsService.editInformInstallItems(Id, modifiedItem)
          : InformInstallItemsService.createInformInstallItems({
            Array: [modifiedItem]
          });

        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest,
          navigated: (navi) =>
            navi &&
            refreshAt === "InstallItem" &&
            commonNavigate(Install_Id)
        });
      }
    );
  };

  const handleSubmitServiceInstall = ({
    ServicePrice,
    Install_Id,
    refreshAt,
  }) => {
    ServicePrice.Array.forEach(({ Id, ...item }) => {
      const modifiedItem = {
        ...item,
        Job_Install_Id: Install_Id,
        Service_Price: Number(item.Service_Price),
        Service_Des: item.Service_Des,
        Service_Unit: item.Service_Unit,
        Remark: item.Remark
      };

      const serviceRequest = Id
        ? InstallServicePricesService.editInstallServicePrices(Id, modifiedItem)
        : InstallServicePricesService.createInstallServicePrices({
          Array: [modifiedItem]
        });

      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest,
        navigated: (navi) =>
          navi &&
          refreshAt === "ServiceInstall" &&
          commonNavigate(Install_Id)
      });
    });
  };

  const handleUploadFile = ({
    destination,
    files,
    Install_Id,
    refreshAt,
  }) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.createFileUploads(destination, files),
      callback: (response) => {
        const InstallFile = {
          Array: response.files.map((item) => ({
            File_Path: `${destination}/${item}`,
            File_Type: ["jpg", "jpeg", "png"].includes(item.split(".").pop())
              ? "Image"
              : "Video",
            Inform_Install_Job_Id: Install_Id
          }))
        };
        handleSubmitInformFiles({ InstallFile, Install_Id, refreshAt });
      }
    });
  };

  const handleSubmitInformFiles = ({
    InstallFile,
    Install_Id,
    refreshAt,
  }) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest:
        InformInstallJobFilesService.createInformInstallJobFiles(InstallFile),
      navigated: (navi) =>
        navi && refreshAt === "InformFiles" && commonNavigate(Install_Id)
    });
  };

  const handleSubmitBom = ({ Item_child }) => {
    Item_child?.Array?.forEach(
      ({
        Id,
        Item_Child_Id,
        Uom_Unit,
        Item_Qty,
        Price_Per_Unit,
        Amount,
        Install_Item_Id,
        ...item
      }) => {
        const modifiedItem = {
          ...item,
          Install_Item_Id: Install_Item_Id,
          Item_Child_Id: Number(Item_Child_Id) || null,
          Item_Qty: Item_Qty,
          Price_Per_Unit: Number(Price_Per_Unit),
          Amount: Number(Amount),
          Uom_Unit: Uom_Unit
        };

        const serviceRequest = Id
          ? InformInstallItemBomsService.editInformInstallItemBoms(
            Id,
            modifiedItem
          )
          : InformInstallItemBomsService.createInformInstallItemBoms({
            Array: [modifiedItem]
          });

        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest,
          navigated: (navi) => navi && commonNavigateBom(state?.searchValue)
        });
      }
    );
  };

  return (
    <>
      {!state?.type ? (
        <CreateInstallationForm
          editData={editData}
          onSubmitCallback={handleSubmit}
        />
      ) : (
        <CreateInstallationBomForm
          editData={editData}
          onSubmitCallbackBom={handleSubmitBom}
        />
      )}
    </>
  );
}
